module.exports = __webpack_public_path__ + "img/graphic-1.58c221eb.png";